export const ACCOUNT_LOGIN = "ACCOUNT_LOGIN";



// WEBPACK FOOTER //
// ./src/actions/accountActions/actionName.js